import {Component, input, computed, output, ChangeDetectionStrategy} from "@angular/core"
import {RouterLink} from "@angular/router"
import {ButtonComponent} from "@common/components/buttons/button/button.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-show-pictures-button",
    imports: [ButtonComponent, RouterLink],
    templateUrl: "./show-pictures-button.component.html",
    styleUrl: "./show-pictures-button.component.scss",
})
export class ShowPicturesButtonComponent {
    readonly $queryParamsKey = input<string | undefined>(undefined, {alias: "queryParamsKey"})
    readonly $entityId = input<string | undefined>(undefined, {alias: "entityId"})
    readonly $queryParams = computed(() => Object.fromEntries([[this.$queryParamsKey(), this.$entityId()]]))
    readonly activated = output<boolean>()
}
